import { useEffect } from 'react';
import {
  useDispatch,
  useSelector,
  type TypedUseSelectorHook,
} from 'react-redux';
import cx from 'classnames';

import config from '@plone/volto/registry';
import { searchContent } from '@plone/volto/actions/search/search';

import ContactFormHeader from '../Common/ContactFormHeader/ContactFormHeader';

import styles from './styles.module.css';
import type { QubicaViewProps, RequestItem } from '../Common/utils';
import GeneralInquiriesForm from './Components/GeneralInquiriesForm';
import NewInvestmentForm from './Components/NewInvestmentForm';

export interface RootState {
  search: Request & {
    subrequests: {
      nations: RequestItem;
    };
  };
}

const FormView = (props: QubicaViewProps) => {
  const dispatch = useDispatch();
  const useTypedSelector: TypedUseSelectorHook<RootState> =
    useSelector<RootState>;
  const Container = config.getComponent('Container').component || 'div';

  const { content } = props;

  useEffect(() => {
    dispatch(
      searchContent(
        '/',
        { portal_type: ['Nation'], fullobjects: 1 },
        'nations',
      ),
    );
  }, [dispatch]);

  const nations = useTypedSelector((state) => state.search.subrequests.nations);
  const nationOptions = nations
    ? nations.items.map((nation) => {
        return { title: nation.title, token: nation['@id'] };
      })
    : [];

  return (
    <Container>
      <ContactFormHeader content={props.content} />

      <div className={cx('has--fullwidth--true', styles.formContainer)}>
        <Container>
          {content['@id'].includes('general-inquiries') ? (
            <div>
              <GeneralInquiriesForm nations={nationOptions} />
            </div>
          ) : (
            <div>
              <NewInvestmentForm nations={nationOptions} />
            </div>
          )}
        </Container>
      </div>
    </Container>
  );
};

export default FormView;
